<template>
<div>
<div class="backdrop active"></div>
    <div class="modal active modalTicketAnimation">
        <div class="mybets-modal">
            <div class="loading-container" v-if="loading && (!isMobile || (isMobile && totalRecords === 0))">
                <img src="../../assets/img/loading.svg">
            </div>
            <div class="modal-close" v-on:click="toggleMybetsModal(false)">
                <i class="iconset icon-close"></i>
            </div>
            <div class="mybets-ticket-type">
                <label for="tickettype-all" class="ticket-type"
                :class="{'is-selected': (selectedProduct == 'ALL')}"
                v-on:click="selectedProduct = 'ALL'">
                    <img class="" src="../../assets/img/icon-ticket-all.svg">{{$t('HISTORYTYPE_ALL')}}
                </label>
                <label for="tickettype-sport" class="ticket-type"
                :class="{'is-selected': (selectedProduct == 'SPORT')}"
                v-on:click="selectedProduct = 'SPORT'">
                    <img class="" src="../../assets/img/icon-ticket-sport.svg">{{$t('HISTORYTYPE_SPORT')}}
                </label>
                <label for="tickettype-lotto" class="ticket-type"
                :class="{'is-selected': (selectedProduct == 'LOTTO')}"
                v-on:click="selectedProduct = 'LOTTO'">
                    <img class="" src="../../assets/img/icon-ticket-lotto.svg">{{$t('HISTORYTYPE_LOTTO')}}
                </label>
            </div>
            <div class="mybets-error" v-if="error != null">
                <div class="mybets-warning-box fadeInDown">
                    <p class="mybets-warning-text">{{error.notice}}</p>
                </div>
            </div>
            <div class="mybets-tickets">
                <p class="mybets-subheading">{{$t('TICKET_STATUS_FILTER_HEADER')}}</p>

                <div class="mybets-ticket-status">
                    <label for="ticketstatus-all" class="ticket-status"
                    :class="{'is-selected': (selectedStatus == 'ALL')}"
                    v-on:click="selectedStatus = 'ALL'">
                        <img src="../../assets/img/icon-ticket-single.svg">{{$t('TICKET_STATUS_FILTER_ALL')}}
                    </label>
                    <label for="ticketstatus-active" class="ticket-status"
                    :class="{'is-selected': (selectedStatus == 'ACTIVE')}"
                    v-on:click="selectedStatus = 'ACTIVE'">
                        <img src="../../assets/img/icon-ticket-active.svg">{{$t('TICKET_STATUS_FILTER_ACTIVE')}}
                    </label>
                    <label for="ticketstatus-win" class="ticket-status"
                    :class="{'is-selected': (selectedStatus == 'WIN')}"
                    v-on:click="selectedStatus = 'WIN'">
                        <img class="close-modal" src="../../assets/img/icon-ticket-win.svg">{{$t('TICKET_STATUS_FILTER_WIN')}}
                    </label>
                    <label for="ticketstatus-lost" class="ticket-status"
                    :class="{'is-selected': (selectedStatus == 'LOST')}"
                    v-on:click="selectedStatus = 'LOST'">
                        <img src="../../assets/img/icon-ticket-lost.svg">{{$t('TICKET_STATUS_FILTER_LOST')}}
                    </label>
                    <label for="ticketstatus-refund" class="ticket-status"
                    :class="{'is-selected': (selectedStatus == 'REFUND')}"
                    v-on:click="selectedStatus = 'REFUND'">
                        <img src="../../assets/img/icon-ticket-refund.svg">{{$t('TICKET_STATUS_FILTER_REFUND')}}
                    </label>
                </div>

                <div class="mybets-container">
                    <div>
                        <div class="mybets-table">
                            <div class="list-heading" v-if="!isMobile">
                                <p class="date">{{$t('TICKET_DATE')}}</p>
                                <p class="ticketcode">{{$t('TICKET_CODE')}}</p>
                                <p class="totalamount">{{$t('TICKET_TOTAL_AMOUNT')}}</p>
                                <p class="totalodd">{{$t('TICKET_TOTAL_ODD')}}</p>
                                <p class="winamount">{{$t('TICKET_WIN_AMOUNT')}}</p>
                                <p class="status">{{$t('TICKET_STATUS')}}</p>
                            </div>
                            <div class="notickets-info"
                            v-if="!isMobile && !loading && totalRecords === 0">
                                <img class="" src="../../assets/img/icon-ticket-all.svg">
                                <p>{{$t('NOTICKETSINHISTORY')}}</p>
                            </div>
                            <div class="tickets-list" v-if="!isMobile">
                                <div class="ticket-item"
                                :class="{
                                    'border-status-active': item.status === 'ACTIVE',
                                    'border-status-win': item.status === 'WIN',
                                    'border-status-lost': item.status === 'LOST',
                                    'border-status-refund': item.status === 'REFUND',
                                }"
                                v-for="(item, index) in transactions"
                                :key="`${index}_${item.ticketCode}`"
                                @click="getTicket({ticketCode: item.ticketCode})">
                                    <p class="date">{{item.paymentTimestamp | getLocalDate}}</p>
                                    <p class="ticketcode">{{item.ticketCode}}</p>
                                    <p class="totalamount">
                                        {{item.sumTotal | formatNum(2)}} {{ $getCurrencyAbbrv(usedCurrency) }} <template
                                        v-if="calculateEurConversion">
                                            ({{getEurValue(item.sumTotal) | formatNum}} {{ $getCurrencyAbbrv('EUR') }})
                                        </template>
                                    </p>
                                    <p class="totalodd">
                                        <template
                                        v-if="item.combinationCount === 1 && item.initialCoefficientSum != null">
                                            {{item.initialCoefficientSum | formatNum(4)}}
                                        </template>
                                        <template v-else>
                                            -
                                        </template>
                                    </p>
                                    <p class="winamount">
                                        {{getTicketWin(item) | formatNum(2)}} {{$getCurrencyAbbrv(usedCurrency)}} <template
                                        v-if="calculateEurConversion">
                                            ({{getEurValue(getTicketWin(item)) | formatNum}} {{ $getCurrencyAbbrv('EUR') }})
                                        </template>
                                    </p>
                                    <p class="status">
                                        <img src="../../assets/img/icon-ticket-active.svg"
                                        v-if="item.status === 'ACTIVE'">
                                        <img src="../../assets/img/icon-ticket-win-color.svg"
                                        v-if="item.status === 'WIN'">
                                        <img src="../../assets/img/icon-ticket-lost-color.svg"
                                        v-if="item.status === 'LOST'">
                                        <img src="../../assets/img/icon-ticket-refund-color.svg"
                                        v-if="item.status === 'REFUND'">
                                    </p>
                                </div>
                            </div>
                            <div class="tickets-list-mobile" v-if="isMobile" ref="ticketlistmobile">
                                <div class="ticket-item"
                                v-for="(item, index) in transactions"
                                :key="`${index}_${item.ticketCode}`"
                                @click="getTicket({ticketCode: item.ticketCode})"
                                :class="{
                                    'border-status-active': item.status === 'ACTIVE',
                                    'border-status-win': item.status === 'WIN',
                                    'border-status-lost': item.status === 'LOST',
                                    'border-status-refund': item.status === 'REFUND',
                                }">
                                    <p class="status">
                                        <img src="../../assets/img/icon-ticket-active.svg"
                                        v-if="item.status === 'ACTIVE'">
                                        <img src="../../assets/img/icon-ticket-win-color.svg"
                                        v-if="item.status === 'WIN'">
                                        <img src="../../assets/img/icon-ticket-lost-color.svg"
                                        v-if="item.status === 'LOST'">
                                        <img src="../../assets/img/icon-ticket-refund-color.svg"
                                        v-if="item.status === 'REFUND'">
                                    </p>
                                    <div class="totalamount">
                                        <p class="subinfo">{{$t('TICKET_TOTAL_AMOUNT')}}</p>
                                        <p>
                                            {{item.sumTotal | formatNum(2)}} <span>{{$getCurrencyAbbrv(usedCurrency)}}</span> <template
                                            v-if="calculateEurConversion">
                                                ({{getEurValue(item.sumTotal) | formatNum}} {{ $getCurrencyAbbrv('EUR') }})
                                            </template>
                                        </p>
                                    </div>
                                    <div class="totalodd">
                                        <p class="subinfo">{{$t('TICKET_TOTAL_ODD')}}</p>
                                        <p
                                        v-if="item.combinationCount === 1 && item.initialCoefficientSum != null">
                                            {{item.initialCoefficientSum | formatNum(4)}}
                                        </p>
                                        <p v-else>-</p>
                                    </div>
                                    <div class="winamount">
                                        <p class="subinfo">{{$t('TICKET_WIN_AMOUNT')}}</p>
                                        <p>
                                            {{
                                                getTicketWin(item) | formatNum(2)
                                            }} <span>{{$getCurrencyAbbrv(usedCurrency)}}</span> <template
                                            v-if="calculateEurConversion">
                                                ({{getEurValue(getTicketWin(item)) | formatNum}} {{ $getCurrencyAbbrv('EUR') }})
                                            </template>
                                        </p>
                                    </div>
                                    <div class="dateticketcode">
                                        <p class="ticketcode">{{item.ticketCode}}</p>
                                        <p class="date">{{item.paymentTimestamp | getLocalDate}}</p>
                                    </div>
                                </div>
                                <div class="ticket-item ticket-item-loading" v-if="loading && transactions.length > 0">
                                    <div class="loading-container">
                                        <img src="../../assets/img/loading.svg">
                                    </div>
                                </div>
                                <div class="notickets-info"
                                v-if="isMobile && !loading && totalRecords === 0">
                                    <img class="" src="../../assets/img/icon-ticket-all.svg">
                                    <p>{{$t('NOTICKETSINHISTORY')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mybets-pagination" v-if="!isMobile">
                        <p class="pagination-info"
                        v-if="!loading && totalRecords > 0">{{$t(
                            'SHOWINGHISTORYTICKETS',
                            {
                                from: ((currentPage - 1) * limit) + 1,
                                to: getMaxShownNumber,
                                total: totalRecords
                            }
                        )}}</p>
                        <p class="pagination-info"
                        v-else-if="!loading">{{$t(
                            'SHOWINGHISTORYTICKETS',
                            {
                                from: 0,
                                to: 0,
                                total: totalRecords
                            }
                        )}}</p>
                        <p v-else></p>

                        <div class="pagination-pages">
                            <p :class="{
                                'disabled': !hasPreviousPage,
                            }">
                                <img src="../../assets/img/icon-arrow-left.svg"
                                @click="navigatePage(false)">
                            </p>
                            <p :class="{'is-selected': page.selected}"
                            v-for="(page, index) in getPaginationData"
                            :key="index"
                            @click="changeToPage(page)">
                                {{page.name}}
                            </p>
                            <p :class="{
                                'disabled': !hasNextPage,
                            }">
                                <img src="../../assets/img/icon-arrow-right.svg"
                                @click="navigatePage(true)">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        <!--
            <div class="pages-promotions-sidebar">
            <img src="../../assets/img/promotion-1.png">
            <img src="../../assets/img/promotion-2.png">
            <img src="../../assets/img/promotion-3.png">
            </div>
        -->
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
} from 'vuex';

import PlayerApi from '../api/Player';

export default {
    name: 'MyBets',
    data()
    {
        return {
            selectedStatus: 'ALL',
            selectedProduct: 'ALL',
            limit: 20,
            currentPage: 1,
            transactions: [],
            fetchingData: false,
            totalRecords: 0,
            error: null,
            infiniteId: 1,
            maxNumberOfPagesShown: 5,
            mobilePreloadItemsCount: 10,
        };
    },
    async created()
    {
        const me = this;

        if (me.globals.publicConfig !== undefined
        && me.globals.publicConfig.website !== undefined
        && me.globals.publicConfig.website.betsHistoryOptions !== undefined)
        {
            if (me.globals.publicConfig.website.betsHistoryOptions.mobilePreloadItemsCount !== undefined)
            {
                me.mobilePreloadItemsCount = me.globals.publicConfig
                    .website.betsHistoryOptions.mobilePreloadItemsCount;
            }

            if (me.globals.publicConfig.website.betsHistoryOptions.maxNumberOfPagesShown !== undefined)
            {
                me.maxNumberOfPagesShown = me.globals.publicConfig.website.betsHistoryOptions.maxNumberOfPagesShown;
            }
        }

        me.setDefaultLimit();

        await me.getTicketList();

        me.$nextTick(() =>
        {
            me.scroll();
        });
    },
    beforeDestroy()
    {
        const me = this;

        me.fetchingData = true;

        if (me.$refs.ticketlistmobile !== undefined)
        {
            me.$refs.ticketlistmobile.removeEventListener('scroll', me.loadMoreTickets());
        }
    },
    methods:
    {
        ...mapActions([
            'getTicket',
            'toggleMybetsModal',
        ]),
        changeToPage(page)
        {
            const me = this;

            if (me.loading)
            {
                return;
            }

            if (page.pageNum !== false)
            {
                me.currentPage = page.pageNum;
            }
        },
        resetData(param = {})
        {
            const me = this;

            me.fetchingData = true;

            me.setDefaultLimit();
            me.currentPage = 1;
            me.transactions = [];
            me.totalRecords = 0;

            if (param.saveStatus === undefined
            || param.saveStatus === false)
            {
                me.selectedStatus = 'ALL';
            }

            if (param.saveProduct === undefined
            || param.saveProduct === false)
            {
                me.selectedProduct = 'ALL';
            }

            me.$nextTick(() =>
            {
                me.fetchingData = false;

                me.getTicketList();
            });
        },
        setDefaultLimit()
        {
            const me = this;

            if (me.globals.publicConfig !== undefined
            && me.globals.publicConfig.website !== undefined
            && me.globals.publicConfig.website.betsHistoryOptions !== undefined)
            {
                if (me.isMobile)
                {
                    if (me.globals.publicConfig.website.betsHistoryOptions.mobileLimit !== undefined)
                    {
                        me.limit = me.globals.publicConfig.website.betsHistoryOptions.mobileLimit;
                    }

                    const optimalMobileItems = Math.ceil(
                        Math.ceil(
                            window.innerHeight / 48.5,
                        ) * 2.5,
                    );

                    if (me.limit < optimalMobileItems)
                    {
                        me.limit = optimalMobileItems;
                    }
                }
                else if (me.globals.publicConfig.website.betsHistoryOptions.desktopLimit !== undefined)
                {
                    me.limit = me.globals.publicConfig.website.betsHistoryOptions.desktopLimit;
                }
            }
        },
        scroll()
        {
            const me = this;

            if (me.$refs.ticketlistmobile !== undefined)
            {
                me.$refs.ticketlistmobile.onscroll = () => me.loadMoreTickets();
            }
        },
        async loadMoreTickets()
        {
            const me = this;

            if (me.isMobile && me.$refs.ticketlistmobile !== undefined)
            {
                const elementContainer = me.$refs.ticketlistmobile;

                const bottomOfWindow = elementContainer.scrollTop
                > ((me.mobilePreloadItemsCount * 48.5 * me.currentPage) - elementContainer.offsetHeight);

                if (!me.loading
                && bottomOfWindow)
                {
                    if (me.totalRecords > me.transactions.length)
                    {
                        const hasChanged = await me.navigatePage(true);

                        if (hasChanged)
                        {
                            me.getTicketList();
                        }
                    }
                }
            }
        },
        async getTicketList()
        {
            const me = this;

            if (me.loading)
            {
                return;
            }

            me.error = null;

            if (!me.isMobile)
            {
                me.transactions = [];
                me.totalRecords = 0;
            }

            me.fetchingData = true;

            const params = {
                limit: me.limit,
                currentPage: me.currentPage,
            };

            if (me.selectedStatus !== 'ALL')
            {
                params.status = [me.selectedStatus];
            }

            if (me.selectedProduct !== 'ALL')
            {
                params.productCodes = [me.selectedProduct];
            }

            const data = await PlayerApi.getTicketList(params);

            if (data.error)
            {
                me.error = data;
                me.fetchingData = false;
                return;
            }

            if (data.data !== undefined
            && data.data.items !== undefined)
            {
                me.transactions.push(...data.data.items);
                me.totalRecords = data.data.totalCount;
            }

            me.$nextTick(() =>
            {
                me.fetchingData = false;
            });
        },
        async navigatePage(next = false)
        {
            const me = this;
            let hasChanged = false;

            if (me.loading)
            {
                return hasChanged;
            }

            if (!next)
            {
                if (!me.hasPreviousPage)
                {
                    return hasChanged;
                }

                hasChanged = true;

                me.currentPage -= 1;
            }
            else
            {
                if (!me.hasNextPage)
                {
                    return hasChanged;
                }

                hasChanged = true;

                me.currentPage += 1;
            }

            return hasChanged;
        },
        getTicketWin(item)
        {
            if (item.status !== 'ACTIVE')
            {
                return item.sumWinReal;
            }

            return item.sumWinEstimate;
        },
        getEurValue(val)
        {
            if (this.calculateEurConversion)
            {
                const eurCoeff = parseFloat(this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRate);

                return parseFloat(val) / eurCoeff;
            }

            return 0;
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'ticketLoading',
            'usedCurrency',
        ]),
        getPaginationData()
        {
            const me = this;
            const paginationData = [];

            if (me.isMobile)
            {
                return paginationData;
            }

            const pagesPerSide = parseInt((me.maxNumberOfPagesShown - 1) / 2, 10);
            let minPageNum = false;
            let maxPageNum = false;

            if (me.currentPage > 1)
            {
                for (let i = 1; i <= pagesPerSide; i += 1)
                {
                    const pageNum = me.currentPage - i;

                    if (pageNum > 0)
                    {
                        paginationData.unshift({
                            pageNum,
                            selected: false,
                            name: pageNum,
                        });

                        minPageNum = pageNum;
                    }
                    else
                    {
                        break;
                    }
                }
            }

            if (minPageNum !== false
            && minPageNum > 1)
            {
                paginationData.unshift(
                    {
                        pageNum: 1,
                        selected: false,
                        name: me.$t('FIRST_PAGE'),
                    },
                    {
                        pageNum: false,
                        selected: false,
                        name: '...',
                    },
                );
            }

            paginationData.push({
                pageNum: me.currentPage,
                selected: true,
                name: me.currentPage,
            });

            if (me.currentPage < me.totalRecords / me.limit)
            {
                for (let i = 1; i <= pagesPerSide; i += 1)
                {
                    const pageNum = me.currentPage + i;

                    if (pageNum - 1 < me.totalRecords / me.limit)
                    {
                        paginationData.push({
                            pageNum,
                            selected: false,
                            name: pageNum,
                        });

                        maxPageNum = pageNum;
                    }
                    else
                    {
                        break;
                    }
                }
            }

            if (maxPageNum !== false
            && maxPageNum < Math.ceil(me.totalRecords / me.limit))
            {
                paginationData.push(
                    {
                        pageNum: false,
                        selected: false,
                        name: '...',
                    },
                    {
                        pageNum: Math.ceil(me.totalRecords / me.limit),
                        selected: false,
                        name: me.$t('LAST_PAGE'),
                    },
                );
            }

            return paginationData;
        },
        getMaxShownNumber()
        {
            const me = this;

            let val = ((me.currentPage - 1) * me.limit) + me.limit;

            if (val > me.totalRecords)
            {
                val = me.totalRecords;
            }

            return val;
        },
        loading()
        {
            const me = this;

            if (me.fetchingData || me.ticketLoading)
            {
                return true;
            }
            return false;
        },
        hasNextPage()
        {
            const me = this;

            if (me.isMobile)
            {
                return (me.transactions.length >= (me.limit * me.currentPage));
            }

            return me.transactions.length >= me.limit;
        },
        hasPreviousPage()
        {
            const me = this;

            return me.currentPage > 1;
        },
        calculateEurConversion()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.hrkEurConversion
                && this.globals.publicConfig.hrkEurConversion.enabled;
        },
    },
    watch:
    {
        currentPage()
        {
            const me = this;

            if (me.isMobile)
            {
                return;
            }

            me.getTicketList();
        },
        selectedProduct()
        {
            const me = this;

            me.resetData({
                saveStatus: true,
                saveProduct: true,
            });
        },
        selectedStatus()
        {
            const me = this;

            me.resetData({
                saveStatus: true,
                saveProduct: true,
            });
        },
        isMobile()
        {
            const me = this;

            me.resetData();
        },
    },
};

</script>
